'use strict';

angular.module('amexReconciliationApp')
  .service('AnalyticsService', function ($window,
                                         $rootScope,
                                         EventLoggingRepository,
                                         UserModel) {
    var self = this;
    var countryCode = 'US';

    UserModel.onCurrentUserChanged($rootScope, function(newUser) {
      var companyId = _.get(newUser, 'companyId', '(unknown)');
      $window.itag_tools = countryCode + ':Corp:AtWorkRecon:Company:' + companyId;
    });

    self.trackMarkAsReviewed = function () {
      trackAction('Check_MarkAsReviewed');
    };

    self.trackCardManagerApproved = function () {
      trackAction('Check_ApproveAsCardManager');
    };

    self.trackSaveAllocations = function () {
      trackAction('Click_SaveAccounting');
    };

    self.trackAccountingTabViewed = function () {
      trackView('TXN:ReviewAccounting');
    };

    self.trackTransactionDetailsTabViewed = function () {
      trackView('TransactionDetails');
    };

    self.trackTransactionListViewed = function () {
      trackView('Transaction');
    };
    
    self.logTransactionSorting = function (columnName) {
      switch(columnName) {
        case 'date':
          EventLoggingRepository.logEvent('DATE_SORT_CLICK');
          break;
        case 'merchantName':
          EventLoggingRepository.logEvent('MERCHANT_SORT_CLICK');
          break;
        case 'details.travelerName':
          EventLoggingRepository.logEvent('TRAVELER_NAME_SORT_CLICK');
          break;
        case 'details.ticketNumber':
          EventLoggingRepository.logEvent('TICKET_NUMBER_SORT_CLICK');
          break;
        case 'amount':
          EventLoggingRepository.logEvent('AMOUNT_SORT_CLICK');
          break;
      }
    };

    self.logAdvancedSearchUsage = function () {
      EventLoggingRepository.logEvent('ADVANCED_SEARCH_USED');
    };
    
    self.logTransactionFiltering = function () {
      EventLoggingRepository.logEvent('TRANSACTION_LIST_FILTER_USED');
    };

    self.logExtendSession = function () {
      EventLoggingRepository.logEvent('EXTEND_SESSION');
    };

    function trackAction(name) {
      if (typeof($window.$iTagTracker) === 'function') {
        $window.$iTagTracker('rmaction', name);
      }
    }

    function trackView(name) {
      if (typeof($window.$iTagTracker) === 'function') {
        $window.$iTagTracker('layertrack', name);
      }
    }

  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/AnalyticsService.js
// module id = 634
// module chunks = 0